<script>
export default {
  name: 'Footer',
  methods: {
    pathOfWeb() {
      return "https://fun.asahi-gf.co.jp/mintialabel/#/"
    },
  },
}
</script>

<template>
  <div>
    <footer class="footer">
  </footer>
  <div class="footer-icon-social">
      <ShareNetwork network="twitter" url="https://fun.asahi-gf.co.jp/mintialabel/#/" 
        title="自分だけのオリジナルミンティアラベルを作ろう！作ったラベルは、実物サイズの印刷用データでダウンロードできます。"
        hashtags="アサヒグループ食品 @asahigf_jpより">
        <div class="thumb-twiter thumbnail">
          <img src="@/assets/images/home-page/pc/icon_twitter.png"/>
        </div>
      </ShareNetwork>
      <ShareNetwork network="facebook" url="https://fun.asahi-gf.co.jp/mintialabel/#/" 
        title="自分だけのオリジナルミンティアラベルを作ろう！作ったラベルは、実物サイズの印刷用データでダウンロードできます。"
        hashtags="アサヒグループ食品">
        <div class="thumb-facebook thumbnail">
          <img src="@/assets/images/home-page/pc/icon_facebook.png"/>
        </div> 
      </ShareNetwork>
      <ShareNetwork network="line" url="https://fun.asahi-gf.co.jp/mintialabel/#/" 
        title="自分だけのオリジナルミンティアラベルを作ろう！作ったラベルは、実物サイズの印刷用データでダウンロードできます。#アサヒグループ食品 @asahigf_jp より">
        <div class="thumb-line thumbnail">
          <img src="@/assets/images/home-page/pc/icon_line.png" alt="line" />
        </div>
      </ShareNetwork>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'footer.scss';
</style>
